<template>
<v-container >
     <v-card-title>
     مشاهده لیست پاسخ ها به درخواست شماره {{$store.getters.tradeRequestNumber}} به تاریخ {{jalaliDate($store.getters.tradeRequestDate)}} از نوع 
     {{$store.getters.tradeRequestCategoryType == 'IndustrialService'? 'ساخت و تولید' :
     $store.getters.tradeRequestCategoryType == 'Product'? 'کالای صنعتی':
     $store.getters.tradeRequestCategoryType == 'ConsultingService'? 'طراحی و مشاوره صنعتی' : 'استانداردهای صنعتی'}}
      <v-spacer/>
      <v-btn color="error" @click="closeForm">بستن</v-btn>

    </v-card-title>
      <v-divider></v-divider>
      <!--  -->
      <v-sheet outlined>
  <v-data-table
      :headers="tradeDisplayResponseHeaders"
      :items="tradeDisplayResponseItems"
      tableClasses="item-table border"
      responsive
      hide-default-footer
      fixed-header
      disable-pagination
      max-height="200"
      item-key="title"
    >     
        
          <template v-slot:[`item.responseDateUtc`]="{ item }">
                    {{ jalaliDate(item.responseDateUtc) }}
          </template>
           <template v-slot:[`item.status`]="{ item }">
            {{ responseStatusDisplayName(item.status) }}
        <!-- {{ item.status == 'Draft' ? 'پیش نویس' :  
        item.status == 'Sent' ? ' ارسال پاسخ':
        item.status == 'Viewed' ? 'مشاهده توسط سفارش گذار':
        item.status == 'Reviewed' ? 'بررسی توسط سفارش گذار':
        ''

         }} -->
      </template>

    </v-data-table>
    </v-sheet>
     <div class="text-center pt-5">
      <v-row>
        <v-col cols="12" sm="2" md="2">
          <v-select
            outlined
            dense
            v-model="itemsPerPage"
            :items="[5, 10, 20]"
            label="تعداد نمایش در صفحه"
          ></v-select>
        </v-col>

        <v-col cols="12" sm="10" md="10">
          <v-pagination
            circle
            v-model="pageNumber"
            :length="pageCount"
            :total-visible="7"
          ></v-pagination>
        </v-col>
      </v-row>
    </div>
</v-container>
</template>

<script>
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
const tradeRequestResponseRepository = () => RepoFactory.get('tradeRequestResponse');
import { RepoFactory } from '@/baseRepository/Factory';
import Helper from '@/core/helpers';
const enumsRepository = () => RepoFactory.get('enums');

import qs from 'qs';
export default {
  mixins: [asyncLoadMixin, reusableMethodsMixin],

  name: '',
  created(){
    if(this.merchantId && this.merchantId.length)
    this.responseStatus()
    this.getData()
  },
  data() {
    return {
        pageNumber:1,
        itemsPerPage:10,
        pageCount:null,
        tradeDisplayResponseItems:[],
        tradeDisplayResponseHeaders:[
      
        {
          value: 'merchantName',
          text: 'پاسخ دهنده',
          sortable: true,
        },
        {
          value: 'responseDateUtc',
          text: 'تاریخ پاسخ',
          sortable: true,
        },
        {
          value: 'status',
          text: 'وضعیت',
          sortable: true,
        },
        {
          value: 'itemsCount',
          text: 'تعداد پاسخ',
          sortable: true,
        },
        // {
        //   value: 'operations',
        //   text: 'مشاهده جزییات',
        //   sortable: true,
        // },
      ],
    };
  },
  watch:{
    merchantId(){
       this.getData()
    },
    selected(){
       this.$emit('selectedItem', this.selected)
    }
  },
   computed: {
    tradeBaseUrl() {
      return this.$store.getters.tradeBaseUrl;
    },
    merchantId() {
      return this.$store.getters.currentMerchant;
    },
    id() {
      return this.$route.params.id;
    },
   },
  methods:{
    getData(){
      let app = this;
      let params = {
        tradeRequestId : this.id,
        PageNumber: this.pageNumber,
        ItemsPerPage:  this.itemsPerPage,
        Orders: [
          {
            column: 'createdTimeUtc',
            order: 'Descending',
          },
        ],
      };
      const loader = this.$loading.show();
      tradeRequestResponseRepository()
        .getTradeRequestsResponseList(
            app.tradeBaseUrl, 
            { MerchantId: this.merchantId }, 
            params, 
            (params) => {
          return qs.stringify(params, { allowDots: true }
        );
        }
        )
        .then((res) => {
          if(res.data.list!=null ){
            this.tradeDisplayResponseItems = res.data.list;
            this.pageCount = Math.ceil(res.data.totalCount / this.itemsPerPage);}
          else{
            this.tradeDisplayResponseItems = []
            this.pageCount=1
          }
          loader.hide()
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide()
        })
        .finally(() => loader.hide());
    },
    closeForm(){
      this.clearStore()
      this.$router.push({ path: `/trade-request`})
    },
    clearStore(){
      this.$store.commit('setTradeRequestFormStatus',false )
      this.$store.commit('setTradeRequestIsEdit',false )
      this.$store.commit('setTradeRequestSelectedForEdit',null )
      this.$store.commit('setTradeRequestShowDetailForm',false )
      this.$store.commit('setTradeRequestSingleItem',null )
      this.$store.commit('setTradeRequestSingleItemForEdit',null )
      this.$store.commit('setTradeRequestItems',[] )
      this.$store.commit('setTradeRequestSelectedForDisplay',null )
      this.$store.commit('setTradeRequestCategoryType',null )
      this.$store.commit('setTradeRequestEditMode',false )
      this.$store.commit('setTradeRequestResponsesPerItem',null )
      this.$store.commit('setTradeRequestNumber',null )
      this.$store.commit('setTradeRequestDate',null )
      this.$store.commit('setTradeRequestResponsesHeader',null )
      this.$store.commit('setTradeRequestSelectedForResponse',null )

  },
   responseStatusDisplayName(title) {
      if (this.responseStatusList.length) {
        let result = this.responseStatusList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    responseStatus() {
      // this.responseStatusList = this.getEnumByTitle('TradeResponseStatus');
      enumsRepository()
        .getEnum('TradeResponseStatus', this.tradeBaseUrl)
        .then((res) => {
          this.responseStatusList = res.data;
        })
        .catch((err) => Helper.handleErrors(err, this));
    },
  }
};
</script>

<style>

</style>